'use strict';

/**
 *
 * @name: Playlist
 *
 */

function PlaylistFactory($rootScope, $resource) {

  'ngInject';

  /*jslint laxbreak: true */
  return $resource(
    $rootScope.apiUrlNew + '/playlist/:id:slugController/:slug:postController/:postId', {
      id: '@id',
      slugController: '@slugController',
      slug: '@slug',
      postController: '@postController',
      postId: '@postId'
    }, {
      getLove: {
        method: 'GET',
        params: {
          slugController: 'isLoved'
        }
      },
      getSlug: {
        method: 'GET',
        params: {
          slugController: 'getbyslug'
        }
      },
      addStory: {
        method: 'POST',
        params: {
          postController: 'post'
        }
      },
      deleteStory: {
        method: 'DELETE',
        params: {
          postController: 'post'
        }
      },
      update: {
        method: 'PUT'
      },
      updateStory: {
        method: 'PUT',
        params: {
          postController: 'post'
        }
      }
    }
  );
}

export default PlaylistFactory;



// WEBPACK FOOTER //
// ./app/components/_api/playlist.factory.js